import { useCallback, useState } from "react";
import { useGetDashboardAiSummaryQuery } from "../../app/useGeneratedApi";

export const useAiSummaryPanel = () => {
  const [dismissed, setDismissed] = useState(false);

  const { data, isLoading, isError } = useGetDashboardAiSummaryQuery({
    refetchOnWindowFocus: false,
  });

  return {
    summary: data?.summary,
    placeholder: data?.placeholder,
    isLoading,
    isError,
    dismissed,
    dismiss: useCallback(() => setDismissed(true), []),
  };
};
